import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CardioProgramService, HelperService, OrganizationService} from 'src/app/services';
import { CardioCategory, IMeal, Organization,} from 'src/app/models';

@Component({
  selector: 'app-cardio-category-select',
  templateUrl: './cardio-category-select.component.html',
  styleUrls: ['./cardio-category-select.component.scss'],
})
export class CardioCategorySelectComponent implements OnInit {

  public categories: CardioCategory[] = [];
  public organization: Organization;
  public searchTerm = "";

  constructor(
    private modalCtrl: ModalController,
    private organizationService: OrganizationService,
    private cardioProgramService: CardioProgramService,
    private helperService: HelperService,
  ) { 
    this.organization = this.organizationService.getAppOrganization();
  }

  async ngOnInit() {
    this.cardioProgramService.getOrganizationCardioCategoriesAsPromise(this.organization.uid).then((categories) => {
      this.categories.push(...categories);
    });
  }

  getFilteredCategories() {
    let filteredCategories = [];
    for (const category of this.categories) {
      if(!this.searchTerm) {
        filteredCategories.push(category);
      } else {
        if(category.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1) {
          filteredCategories.push(category);
        }
      }
    }
    return filteredCategories.sort((a,b) => {
      return a.title.localeCompare(b.title);
    });
  }

  selectCategory(category) {
    this.modalCtrl.dismiss({ status: "selected", data: this.helperService.copyObject(category) }, "selected");
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }

}
